/** Cabeçalho em duas linhas compartilhado; ações são fornecidas e autorizadas pelo domínio. */
import type { CSSProperties, ReactNode } from 'react';
import { cn } from '@/lib/utils';

export function KanbanColumnHeader({ name, color, count, overdue = 0, isFinal = false, handle, actions, compact = false }: {
  name: string; color: string; count: number; overdue?: number; isFinal?: boolean; handle?: ReactNode; actions?: ReactNode;
  /** Reduz somente os espaços verticais; os outros Kanbans preservam a densidade padrão. */
  compact?: boolean;
}) {
  return (
    <div 
      className={cn('kanban-column-header rounded-t-lg border-b border-border/50 px-3', compact ? 'py-1' : 'py-3')}
      // A cor pertence ao catálogo; intensidade e fallback pertencem ao tema global.
      style={{ '--kanban-phase-color': color || 'hsl(var(--muted-foreground))' } as CSSProperties}
    >
      <div className="mb-2 flex items-center gap-2">
        {handle && (
          <div className="kanban-column-handle flex shrink-0 items-center">
            {handle}
          </div>
        )}
        <span className="kanban-phase-dot h-3 w-3 shrink-0 rounded-full" />
        <span className="flex-1 truncate text-sm font-semibold" title={name}>{name}</span>
        <span className="shrink-0 rounded bg-background/50 px-1.5 py-0.5 text-xs text-muted-foreground">{count}</span>
      </div>
      <div className="flex min-h-6 items-center justify-between gap-2">
        <div className="flex min-w-0 flex-1 items-center gap-1">
          {overdue > 0 && (
            <span className={cn('whitespace-nowrap rounded bg-destructive/10 px-1.5 py-0.5 text-[10px] font-medium text-destructive')}>
              {overdue} atrasada{overdue > 1 ? 's' : ''}
            </span>
          )}
          {isFinal && (
            <span className="whitespace-nowrap rounded bg-success/10 px-1.5 py-0.5 text-[10px] text-success">
              Final
            </span>
          )}
        </div>
        <div className="flex shrink-0 items-center gap-0.5">
          {actions}
        </div>
      </div>
    </div>
  );
}
